//const API_BASE = ;
const API_BASE = (process.env.NODE_ENV === "development" ? 
"https://localhost:5001/"
:"https://uichecker.com/api/");

export const urlConfig = {
    API_URL : API_BASE,
    API_FILE_URL : API_BASE + "projects/files"
}